import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { useI18n } from "../i18n-context";

export default function FAQPage() {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(0);

  return (
    <>
      <PageHeader
        kicker={t.faq.kicker}
        title={t.faq.title}
        lead={lang === "ar"
          ? "إجابات سريعة على أكثر الأسئلة شيوعاً حول خدمات التوصيل، الأمان، التغطية، والشراكات."
          : "Fast answers to the most common questions about our delivery service, security, coverage, and partnerships."}
      />

      <section className="pb-24">
        <div className="container max-w-4xl">
          <div className="space-y-3">
            {t.faq.items.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={i}
                  className={`rounded-2xl border-2 overflow-hidden transition-all ${
                    isOpen ? "border-brand-blue bg-white" : "border-brand-ink/10 bg-white"
                  }`}
                  data-testid={`faq-item-${i}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 p-6 text-start"
                    data-testid={`faq-toggle-${i}`}
                  >
                    <span className="font-display font-bold text-lg text-brand-ink">{f.q}</span>
                    <ChevronDown
                      className={`h-5 w-5 flex-shrink-0 text-brand-blue transition-transform ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-6 pb-6 text-brand-ink/70 leading-relaxed">{f.a}</div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="mt-12 rounded-3xl bg-brand-paper border-2 border-brand-ink/10 p-8 text-center">
            <h3 className="font-display font-bold text-2xl text-brand-ink mb-3">
              {lang === "ar" ? "لم تجد إجابتك؟" : "Didn't find your answer?"}
            </h3>
            <p className="text-brand-ink/65 mb-6">
              {lang === "ar"
                ? "فريقنا متاح للإجابة على استفساراتك خلال ساعات العمل الرسمية."
                : "Our team is here to answer any question during office hours."}
            </p>
            <Link to="/contact" className="btn-primary">
              {t.nav.contact}
              <ArrowRight className="h-4 w-4 flip-x" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
